<template lang="html">
    <div>
        <div class="editor">
            <div ref="toolbar" class="toolbar">
                <div class="w-e-menu" style="z-index:10001;" @click="addUploadFile(1)"><i class="w-e-icon-image"></i></div>
                <div class="w-e-menu" style="z-index:10001;" @click="addUploadFile(0)"><i class="w-e-icon-play"></i></div>
            </div>
            <div ref="editor" class="text"></div>
        </div>
        <!-- 上传文件 start -->
        <upload 
        :upload_type="upload_type" 
        :upload_show="upload_show"
        :issue_id="issue_id"
        v-if="upload_show"
        @closeUpload="closeUpload"
        @checkFile="checkFile">
        </upload>
        <!-- 上传文件 end -->
    </div>
</template>

<script>
    import E from 'wangeditor'
	import Upload from '@/components/media/upload'
    export default {
        name: 'editoritem',
		components: {
			Upload
		},
        data() {
            return {
                // uploadPath,
                editor: null,
                info_: null,
                upload_type:'',
                upload_show:false,
                is_init:true,
            }
        },
        model: {
            prop: 'value',
            event: 'change'
        },
        props: {
            value: {
                type: String,
                default: ''
            },
            isClear: {
                type: Boolean,
                default: false
            },
            issue_id: {
                type: String,
                default: ''
            },
            form: {
                type: String,
                default: ''
            }
        },
        watch: {
            isClear(val) {
                // 触发清除文本域内容
                if (val) {
                    this.editor.txt.clear()
                    this.info_ = null
                }
            },
            value: function(value) {
                //防止光标跳动，循环change
                if (!value) {
                    this.editor.txt.html(this.value)
                }else{
                    if(this.form == 'explain'){
                        return false;
                    }else{
                        if(this.is_init){
                            this.is_init = false;
                            this.editor.txt.html(this.value);
                        }
                    }
                }
            },    
            //value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
        },
        mounted() {
            
            this.seteditor()
            this.editor.txt.html(this.value)
        },
        created(){
        },
        methods: {
            seteditor() {
                this.editor = new E(this.$refs.toolbar, this.$refs.editor);
                // 配置菜单
                this.editor.customConfig.menus = [
                    'head', // 标题
                    'bold', // 粗体
                    'fontSize', // 字号
                    'fontName', // 字体
                    'italic', // 斜体
                    'underline', // 下划线
                    'strikeThrough', // 删除线
                    'foreColor', // 文字颜色
                    'backColor', // 背景颜色
                    //'link', // 插入链接
                    'list', // 列表
                    'justify', // 对齐方式
                    'quote', // 引用
                    //'emoticon', // 表情
                    'table', // 表格
                    //'code', // 插入代码
                    'undo', // 撤销
                    'redo', // 重复
                    //'fullscreen', // 全屏
                    // 'image', // 插入图片
                    // 'video', // 插入视频
                ]

                this.editor.customConfig.onchange = (html) => {
                    this.info_ = html // 绑定当前逐渐地值
                    this.$emit('change', this.info_) // 将内容同步到父组件中
                }
                //粘贴处理
                this.editor.customConfig.pasteTextHandle = (content)=>{
                    if (content == '' && !content) return ''
                    var str = content
                    str = str.replace(/<xml>[\s\S]*?<\/xml>/ig, '')
                    str = str.replace(/<style>[\s\S]*?<\/style>/ig, '')
                    str = str.replace(/[ | ]*\n/g, '\n')
                    str = str.replace(/&nbsp;/ig, '')
                    return str
                }
                // 创建富文本编辑器
                this.editor.create()
            },
            //添加上传
            addUploadFile(type){
                let _this = this;
                _this.upload_type   = type;
                _this.upload_show   = true;
            },
			//关闭上传框
			closeUpload(){
				let _this = this;
				_this.upload_show = false;
			},
            //选择文件
            checkFile(file){
                console.log(file);
				let _this       = this;
				let file_src 	= file.url;
				let _html = "";
                switch(_this.upload_type){
					case 0:
						_html += "<p style='text-align: center;'><video style='object-fit: fill;border-radius: 10px;' width='380' height='220' ";
                        _html += "src='" + file_src + "' controls></video></p><p>&nbsp;</p>";
					break;
					case 1:
						_html = '<p><img class="iphone_img_show_style" style="width:380px;border-radius: 10px;" src="' + file_src + '"></img></p>';
					break;
				}

                var $selectionElem = _this.editor.selection.getSelectionContainerElem();

                $(_html).insertAfter($selectionElem);
                //_this.editor.txt.append(_html);
                _this.$emit('change', _this.editor.txt.html()) // 将内容同步到父组件中
                _this.closeUpload();
            },
        }
    }
</script>

<style lang="css">
.editor {width: 100%;margin: 0 auto;position: relative;z-index: 0;}
.toolbar {border: 1px solid #ccc;position: sticky;top: -2px;z-index: 99999;background: #fff;}
.text {border: 1px solid #ccc;min-height: 200px;}
.w-e-text{min-height: 200px;}
</style>


// WEBPACK FOOTER //
// src/components/media/editor.vue